"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COUNTRY_OPTIONS = void 0;
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
exports.COUNTRY_OPTIONS = interfaces_1.COUNTRY_CODES.map(function (cc) { return ({ value: cc, label: (0, end2end_1.getRegionName)(cc) }); })
    .filter(function (opt) { return !!opt.value && !!opt.label; });
exports.COUNTRY_OPTIONS.sort(function (c1, c2) { return c1.label.localeCompare(c2.label); });
